/**
 * Where Stripe Checkout sends the browser back if the prospect cancels
 * without paying.
 *
 * Mounted at the top level as /signup/payment-cancelled, matching the
 * cancel_url SelfServeSignupService.submit builds
 * (`${customerBaseUrl}/signup/payment-cancelled`).
 *
 * The flow's answers lived only in the tab's memory, and the off-domain trip
 * to Stripe cleared them, so there is nothing to resume: say so, and send the
 * prospect back to the start rather than to a screen that would redirect.
 */

import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import StandaloneShell from '../../components/standalone-shell';

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <StandaloneShell>
      <Result
        status="info"
        title="Payment wasn't completed"
        subTitle="No charge was made. Your answers weren't saved, so start over below to get your rate again - it takes about two minutes."
        extra={
          <Button type="primary" onClick={() => navigate('/selfserve/qualify')}>
            Start over
          </Button>
        }
      />
    </StandaloneShell>
  );
};

export default PaymentCancelled;
